+(() => {
  const script = document.currentScript;
  const brandId = script?.dataset.r3vyBrand || '';
  const params = new URLSearchParams(window.location.search);
  const emailClickId = params.get('eid') || '';
  const medium = params.get('utm_medium') || '';
  if (!brandId || (!emailClickId && medium !== 'email')) return;

  const attributes = {
    r3vy_brand: brandId,
    r3vy_eid: emailClickId,
    r3vy_utm_source: params.get('utm_source') || '',
    r3vy_utm_medium: medium,
    r3vy_utm_campaign: params.get('utm_campaign') || '',
    r3vy_utm_content: params.get('utm_content') || ''
  };

  try {
    window.sessionStorage.setItem('r3vy_email_attribution', JSON.stringify(attributes));
  } catch {
    // Cart attributes remain the durable attribution channel.
  }

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes })
  }).catch(() => {
    // Attribution must never interrupt the storefront.
  });
})();

